var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgTutorialStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 188,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#org-tutorial-step-2_svg__clip0_9824_14693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.86 30.542c-2.995-.174-6.397.544-8.82 2.4-1.487 1.138-2.8 2.638-3.917 4.146-1.524 2.052-2.8 4.205-3.46 6.691-.711 2.675-1.103 5.88-.08 8.511 1.182 3.06 3.206 5.952 5.665 8.12 1.132 1 2.807-.66 1.668-1.668-1.965-1.732-3.568-3.922-4.7-6.278-1.074-2.233-1-4.64-.515-7.032.522-2.559 1.668-4.596 3.14-6.713.378-.536.335-.47.77-.978.61-.704 1.19-1.428 1.879-2.066 2.292-2.11 5.288-2.958 8.37-2.784 1.516.087 1.51-2.27 0-2.356v.007z",
    fill: "url(#org-tutorial-step-2_svg__paint0_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.48 60.598c2.307 1.61 5.158 2.334 7.9 2.726 1.262.181 2.538.45 3.815.493 1.277.043 2.38-.334 3.51-.834.581-.253.719-1.109.422-1.61-.349-.6-1.03-.68-1.61-.42-.871.385-1.713.566-2.663.493-1.117-.087-2.234-.297-3.337-.464-2.393-.355-4.838-1.015-6.847-2.414-1.248-.87-2.423 1.175-1.19 2.037v-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint1_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.45 94.395c-.544-1.834-.37-3.973-.203-5.85.181-2.074.443-4.19.943-6.213 1.037-4.205 4.156-7.489 8.219-8.99 1.32-.485 2.684-.826 4.018-1.268 1.574-.515 3.127-1.102 4.766-1.356 1.494-.232.863-2.5-.624-2.269-1.487.232-2.989.761-4.454 1.255-1.313.442-2.655.782-3.96 1.24-2.474.862-4.664 2.188-6.514 4.052-3.496 3.523-4.127 8.148-4.679 12.867-.268 2.306-.45 4.915.218 7.17.428 1.45 2.706.834 2.27-.623v-.015z",
    fill: "url(#org-tutorial-step-2_svg__paint2_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.463 64.999c-3.729-2.001-7.856-.776-11.57.601-.595.225-1.001.798-.82 1.45.16.573.849 1.044 1.451.82 3.025-1.124 6.666-2.495 9.749-.842 1.335.718 2.532-1.312 1.19-2.037V65z",
    fill: "url(#org-tutorial-step-2_svg__paint3_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.333 44.947c1.596-1.458 4.092-2.74 6.326-2.429.856.123 1.683.478 2.48.783l.349.13c.225.095-.225-.108.036.022.29.138.58.29.863.442 1.944 1.023 3.808 2.654 4.57 4.8.667 1.87.102 4.414-.588 6.198-.544 1.413 1.734 2.03 2.27.623.85-2.21 1.372-5.27.552-7.56-.957-2.676-3.163-4.8-5.621-6.098-1.538-.804-3.316-1.594-5.056-1.703-2.873-.181-5.782 1.232-7.856 3.124-1.125 1.022.544 2.69 1.668 1.668h.007z",
    fill: "url(#org-tutorial-step-2_svg__paint4_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 54.603c-.907 1.71-2.597 3.074-4.243 4.045-1.647.971-3.62 1.051-5.477.82-.631-.08-1.175.594-1.175 1.174 0 .703.544 1.102 1.175 1.174 2.27.276 4.671.036 6.666-1.138s3.997-2.842 5.085-4.893c.71-1.342-1.32-2.53-2.038-1.19l.007.008z",
    fill: "url(#org-tutorial-step-2_svg__paint5_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.783 124.727c-1.444-1.892-2.691-3.966-4.004-5.952a928.76 928.76 0 01-7.218-11.07c-1.994-3.11-4.011-6.22-5.853-9.431-.247-.428-.48-.87-.711-1.305-.044-.073-.16-.385-.022-.037-.044-.116-.087-.232-.123-.348-.13-.391-.247-.797-.349-1.203-.5-1.943-1.03-4.299-.522-6.293.29-1.138 1.4-1.732 2.263-2.5 1.219-1.08 2.423-2.19 3.678-3.227 2.727-2.261 5.738-4.074 9.256-4.755 1.487-.29.856-2.56-.624-2.27-3.264.639-6.202 2.19-8.828 4.198-1.219.935-2.38 1.936-3.525 2.958-1.146 1.022-2.3 1.914-3.359 2.943-1.66 1.61-1.48 4.357-1.204 6.46.232 1.761.544 3.66 1.335 5.277 1.436 2.936 3.358 5.698 5.114 8.453a942.32 942.32 0 007.558 11.664c1.676 2.545 3.264 5.213 5.114 7.634.392.507 1.008.768 1.61.42.5-.282.806-1.109.421-1.609l-.007-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint6_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.012 74.198c2.3 1.537 5.47 2.233 8.219 2.24 2.749.007 5.65-1.297 7.841-3.08 4.157-3.365 5.585-9.222 3.59-14.152-1.994-4.93-7-8.068-12.367-7.822-2.756.13-5.288 1.03-7.275 2.958-1.125 1.087-2.046 2.378-2.916 3.668-1.61 2.392-2.438 5.785-1.98 8.656.456 2.87 2.603 5.553 4.649 7.344 1.139.993 2.814-.667 1.668-1.668-1.625-1.413-3.104-3.327-3.815-5.379-.66-1.914-.087-4.53.696-6.336.385-.877.965-1.66 1.509-2.443.377-.536.355-.507.79-1 .537-.602 1.06-1.19 1.662-1.726.841-.754 1.893-1.145 2.981-1.42 4.272-1.073 9.053.616 11.396 4.407s2.045 8.438-.747 11.773c-1.669 1.994-4.302 3.574-6.92 3.835-2.62.261-5.68-.478-7.791-1.885-1.262-.848-2.445 1.197-1.19 2.037v-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint7_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.724 127.438c-4.962-.065-9.916-.029-14.871.232-4.127.21-8.443.261-12.418 1.53-3.612 1.152-6.528 3.487-8.269 6.872-1.632 3.175-2.249 6.815-2.184 10.36.145 7.662 3.504 17.326 11.896 19.109 4.998 1.059 10.323.761 15.4.689 2.59-.036 5.172-.073 7.762-.116 1.044-.015 2.306.13 3.257-.392.95-.522 1.349-1.515 1.421-2.559.095-1.392-.108-2.849-.196-4.241-.087-1.391-.181-2.747-.275-4.117a499.868 499.868 0 01-.559-8.671c-.312-5.835-.406-11.7.218-17.521.159-1.508-2.198-1.494-2.358 0-1.022 9.511-.123 19.087.508 28.599.073 1.138.145 2.276.211 3.414.029.566.065 1.131.087 1.689.014.326.152 1.03-.109 1.283-.232.232-.842.138-1.146.138-.588.007-1.175.015-1.763.029-1.291.022-2.59.036-3.881.058-4.809.073-9.64.261-14.442-.109-2.183-.166-4.49-.398-6.441-1.464-1.719-.942-3.018-2.458-4.026-4.11-1.777-2.915-2.778-6.322-3.097-9.707-.588-6.257 1.008-13.811 7.391-16.515 3.837-1.624 8.219-1.624 12.31-1.848 5.186-.283 10.38-.334 15.574-.269 1.516.022 1.516-2.334 0-2.356v-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint8_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.25 109.945c-.725-6.604-6.39-11.976-13.136-11.874-1.894.029-3.758.42-5.608.739-1.537.268-3.082.362-4.635.507-.348.037-.703.08-1.051.08-.407 0-.385.015-.864-.145-1.211-.406-2.379-1.24-3.46-1.92-1.429-.9-2.778-1.965-3.786-3.336-.762-1.043-1.313-2.218-1.821-3.392-.457-1.052-1.023-2.103-1.291-3.226-.305-1.262-.08-2.574.225-3.814.754-3.059 2.14-5.995 4.461-8.177 1.77-1.66 3.939-2.537 6.253-3.117 1.951-.486 3.938-.363 5.911.181 1.676.457 3.381 1.116 4.882 1.994 1.32.775 2.365 2.11 3.228 3.349.791 1.13 1.313 2.211 1.661 3.545.363 1.413.61 2.856 1.067 4.24.457 1.385 1.211 2.473 2.205 3.611.993 1.138 2.074 2.363 3.329 3.328 2.662 2.037 5.774 2.718 9.067 2.203 2.771-.435 5.165-1.834 7.247-3.668s3.01-4.132 3.54-6.677c.384-1.848.435-3.603.065-5.459-.109-.558-.254-1.101-.392-1.652 0 .021-.08-.42-.043-.203.036.239-.022-.276-.022-.247a5.748 5.748 0 00-.261-1.145c-.443-1.37-1.023-2.704-1.516-4.06-.45-1.24-.921-2.48-1.465-3.683-1.488-3.27-3.439-6.162-5.687-8.953-2.249-2.79-4.57-4.944-7.508-6.814-2.938-1.87-5.883-3.248-8.908-4.72a115.262 115.262 0 01-4.526-2.298c-1.335-.725-2.524 1.313-1.19 2.037 5.803 3.147 12.354 5.408 17.286 9.932 1.299 1.19 2.387 2.552 3.482 3.922 1.233 1.537 2.408 3.117 3.358 4.85 1.342 2.45 2.365 4.944 3.323 7.568.885 2.422 1.82 4.894 1.98 7.496.159 2.603-.66 5.785-2.445 7.728-1.683 1.834-3.982 3.22-6.419 3.698-3.076.608-5.999-.233-8.306-2.342a26.071 26.071 0 01-3.141-3.429c-.79-1.044-1.051-2.487-1.342-3.734-.311-1.319-.565-2.667-1.08-3.929-.544-1.34-1.429-2.537-2.329-3.653-1.001-1.247-2.14-2.393-3.583-3.125-1.581-.797-3.235-1.5-4.94-1.972-2.176-.601-4.432-.768-6.652-.304-2.219.464-4.308 1.21-6.107 2.465-2.517 1.754-4.389 4.262-5.593 7.075-1.139 2.66-2.133 5.88-1.356 8.772.319 1.181.914 2.298 1.4 3.414.486 1.117 1.008 2.277 1.711 3.306 1.843 2.697 4.679 4.603 7.566 6.061.827.42 1.668.746 2.611.783.835.029 1.691-.131 2.525-.182 3.67-.217 7.478-1.703 11.156-.971 3.003.602 5.6 2.581 7.152 5.198.747 1.261 1.255 2.675 1.415 4.139.159 1.465 2.524 1.508 2.357 0z",
    fill: "url(#org-tutorial-step-2_svg__paint9_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.723 45.33c-6.978-1.543-14.239-.695-20.92 1.704-6.68 2.4-13.405 6.163-18.141 11.47-2.51 2.812-4.404 6.132-5.956 9.554-1.552 3.422-2.822 7.17-3.503 10.954a42.035 42.035 0 00-.639 5.473c-.05 1.008-.087 1.972-.275 2.965-.124.66-.124 1.283-.073 1.943.08 1.073.015 2.117.08 3.175.08 1.218.305 2.436.53 3.632.47 2.487 1.059 5.155 2.43 7.322.573.914 1.312 1.704 2.06 2.472 1.08 1.124 2.132 2.277 3.111 3.494.98 1.218 2.612-.492 1.669-1.667-1.364-1.696-3.054-3.182-4.374-4.872-1.32-1.689-1.857-3.82-2.3-5.82a50.305 50.305 0 01-.609-3.256c-.073-.457-.13-.92-.152-1.377-.008-.181-.015-.355 0-.537-.008.276.05-.5.058-.623.036-1.204-.298-2.392-.058-3.581.37-1.813.26-3.705.457-5.539.747-7.01 3.46-14.13 7.522-19.892 4.062-5.764 10.228-9.432 16.393-12.063 6.913-2.951 14.675-4.292 22.088-2.654 1.48.326 2.111-1.943.624-2.269l-.022-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint10_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.767 77.504c-3.395-1.153-7.087.464-8.981 3.393-1.835 2.834-2.067 6.85-.29 9.772 1.915 3.153 6.108 4.118 9.561 3.465 1.936-.37 3.271-1.61 4.403-3.146 1.131-1.537 2.074-3.14 2.183-5.06.239-4.212-3.271-7.395-7.101-8.323-1.473-.362-2.104 1.914-.624 2.27 2.502.608 4.853 2.261 5.317 4.95.247 1.45-.298 2.72-1.081 3.915-.704 1.08-1.538 2.357-2.785 2.857-1.248.5-2.721.413-3.997.196-1.277-.218-2.597-.718-3.467-1.777-1.553-1.884-1.596-4.77-.646-6.93 1.168-2.646 4.033-4.292 6.876-3.328 1.437.486 2.061-1.783.624-2.269l.008.015z",
    fill: "url(#org-tutorial-step-2_svg__paint11_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.104 165.527c-.036 1.479.189 2.878.276 4.349.13 2.32.014 4.647-.051 6.967-.058 2.189.138 4.314.261 6.496.029.5.043 1 .022 1.5 0 .066-.08.95-.08.95s.791-.515.646-.428c-.189.116.224 0-.08.015-.211.014-.421.029-.631.036-2.372.094-4.759-.007-7.131.007-.703 0-1.4 0-2.089.145-.399.08-.377.131-.101.044.029-.008.319-.008.007-.008-.348 0-.697.022-1.037.022-4.092.015-8.168-.29-12.259-.362-7.827-.138-15.676 0-23.502.021-7.465.022-14.929.073-22.393.153-4.454.043-8.9.101-13.354.159-4.185.058-8.363-.08-12.549-.072-2.074 0-4.185.246-6.245.079-1.72-.145-3.46-.63-4.984-1.442-1.523-.812-2.858-1.885-3.597-3.422-.914-1.899-.958-4.306-1.132-6.372-.21-2.566.029-5.068.174-7.627.16-2.747.152-5.509.181-8.264.03-2.494.073-4.995.037-7.489-.022-1.638.087-3.276.13-4.915.051-1.776-.123-3.523-.123-5.292 0-2.276.189-4.545.21-6.822.03-2.551.066-5.096.102-7.648.065-4.828.116-9.656-.007-14.484-.058-2.313-.16-4.618-.312-6.923-.102-1.508-2.46-1.516-2.358 0 .682 10.084.348 20.218.21 30.31-.028 2.167-.26 4.335-.188 6.502.058 1.805.138 3.574.073 5.379-.095 2.661-.073 5.314-.102 7.975-.03 2.66-.058 5.198-.094 7.793-.044 2.95-.414 5.894-.421 8.837 0 1.682.167 3.364.363 5.038.254 2.19.53 4.423 1.864 6.257 2.176 2.986 5.89 4.502 9.466 4.908 2.125.246 4.309-.015 6.441-.029 2.133-.015 4.106.043 6.166.087 4.606.087 9.22-.051 13.826-.102a3321.45 3321.45 0 0124.039-.203c8.015-.036 15.718-.036 23.574-.036 4.918 0 9.822.246 14.747.341.936.021 1.879.05 2.814.007.276-.015.581-.015.849-.087.29-.08.588-.116.123-.051.305-.043-.29 0 .066-.007 2.248-.073 4.49-.007 6.738-.015.958 0 1.995.066 2.938-.13 1.654-.348 1.378-2.74 1.32-4.031-.094-2.276-.341-4.502-.275-6.793.065-2.29.188-4.748.043-7.119-.108-1.681-.304-2.588-.261-4.197.036-1.515-2.321-1.515-2.357 0l.007-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint12_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.456 89.915c-5.542-.109-11.084-.457-16.568.58-2.197.413-4.098 1.508-5.396 3.364-1.03 1.479-1.437 3.342-1.582 5.103-.268 3.197.421 7.873 3.547 9.599.87.478 1.741.493 2.699.616 1.588.21 3.126.565 4.73.587 3.358.051 6.716.08 10.075.123 6.738.08 13.477.261 20.216.145 3.199-.051 6.39-.362 9.597-.406 2.88-.043 5.752.145 8.624.377 3.032.247 6.086.616 9.133.471 3.409-.166 6.782-.703 10.191-.884 6.761-.37 13.543-.029 20.289.442 2.125.152 4.251.334 6.383.399 1.748.058 3.533.065 5.274.297.058.007.355.051.544.109.116.036-.145-.174.021.043.167.218.32.399.421.667.457 1.167.232 2.574.225 3.792-.014 2.697.189 5.393.305 8.083.065 1.486.087 2.972.072 4.466-.014 1.493 2.343 1.515 2.358 0 .029-2.741-.131-5.467-.269-8.2a83.438 83.438 0 01-.116-4.038c0-1.348.116-2.682-.123-4.008-.196-1.095-.769-2.27-1.755-2.857-.515-.304-1.183-.348-1.763-.413-1.697-.196-3.409-.232-5.114-.283-5.397-.174-10.772-.761-16.169-.928-3.293-.101-6.586-.108-9.872.044-3.286.152-6.666.638-10.01.87-5.84.413-11.722-.761-17.569-.798-3.082-.014-6.165.298-9.248.377-3.264.087-6.521.066-9.785.029-6.594-.072-13.18-.159-19.774-.232-1.625-.021-3.214-.014-4.817-.29-.747-.13-1.487-.261-2.234-.348-.45-.05-.776-.029-1.175-.188-1.153-.457-1.813-1.965-2.147-3.139-.892-3.096-.762-7.46 2.01-9.598 1.66-1.284 4.214-1.4 6.216-1.588 2.807-.261 5.636-.203 8.45-.13 1.371.036 2.742.08 4.113.108 1.516.03 1.516-2.327 0-2.356l-.007-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint13_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.035 92.314c1.516 0 1.516-2.356 0-2.356s-1.516 2.356 0 2.356z",
    fill: "url(#org-tutorial-step-2_svg__paint14_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.708 89.813c-2.677-.05-5.354-.029-8.023-.058-.638-.007-1.175.544-1.175 1.175 0 .63.537 1.167 1.175 1.174 2.677.03 5.353.015 8.023.058.638.015 1.175-.55 1.175-1.174 0-.624-.537-1.167-1.175-1.175z",
    fill: "url(#org-tutorial-step-2_svg__paint15_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.467 99.52c0-2.363-.239-4.719-.682-7.031-.116-.61-.878-1.008-1.451-.82-.645.21-.95.798-.819 1.45a33.13 33.13 0 01.602 6.409c0 .616.544 1.203 1.175 1.174.631-.029 1.175-.515 1.175-1.174v-.008z",
    fill: "url(#org-tutorial-step-2_svg__paint16_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.649 51.616c-.116-.08-.254-.167-.363-.26.066.057.13.108.03.02-.059-.05-.117-.093-.175-.144a9.3 9.3 0 01-.624-.573c-.21-.21-.413-.428-.609-.652-.087-.102-.174-.203-.261-.312-.044-.058-.102-.116-.138-.174.08.123.073.094 0-.007-.696-.92-1.277-1.929-1.799-2.958-.283-.551-1.102-.754-1.61-.42-.566.362-.718 1.022-.42 1.609 1.16 2.29 2.661 4.415 4.787 5.9.507.356 1.334.11 1.61-.42.32-.601.116-1.232-.42-1.609h-.008z",
    fill: "url(#org-tutorial-step-2_svg__paint17_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.507 47.788c1.516-1.24 3.627-.58 5.15.261.784.428 1.56.87 2.321 1.327.37.218.733.442 1.096.674l.457.305c.283.195-.116-.124.145.123 1.11 1.03 2.778-.63 1.668-1.667-.667-.617-1.509-1.08-2.285-1.537a93.47 93.47 0 00-2.51-1.421c-2.451-1.341-5.447-1.58-7.71.268-.494.406-.421 1.247 0 1.667.486.486 1.175.406 1.668 0z",
    fill: "url(#org-tutorial-step-2_svg__paint18_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.344 42.33c-4.73-.805-6.775-5.72-8.32-9.678-.232-.595-.79-1-1.45-.82-.566.153-1.06.856-.82 1.45 1.022 2.61 2.067 5.227 3.83 7.438 1.523 1.914 3.685 3.473 6.136 3.886.624.109 1.27-.167 1.451-.82.152-.565-.196-1.34-.82-1.45l-.007-.006z",
    fill: "url(#org-tutorial-step-2_svg__paint19_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.435 33.942c2.307.638 4.723 1.617 6.616 3.117a5.101 5.101 0 011.726 2.48c.174.536.29 1.087.37 1.638.036.26.065.522.094.783.015.138.022.283.037.42.051.348-.037-.08.312-.268l.594-.16h-.079c.196.051.399.102.594.16l-.079-.058c-.515-.377-1.313-.087-1.611.42-.348.595-.094 1.24.421 1.61.914.66 1.966-.189 2.169-1.11.167-.739-.073-1.688-.189-2.428-.246-1.566-.776-3.052-1.799-4.277-1.022-1.225-2.437-2.03-3.8-2.74a24.399 24.399 0 00-4.759-1.87c-1.465-.407-2.09 1.87-.624 2.268l.007.015z",
    fill: "url(#org-tutorial-step-2_svg__paint20_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.591 30.368a.524.524 0 01.391-.116c.174.007.182 0 .008-.036.145.087-.232-.102-.225-.102a14.19 14.19 0 01-2.184-1.32c-.87-.63-1.653-1.391-2.357-2.196a14.11 14.11 0 01-2.996-5.734c-.377-1.465-2.655-.848-2.27.623.696 2.697 2.096 5.191 4.004 7.22.943 1.001 2.016 1.886 3.177 2.625 1.037.66 3.068 2.023 4.113.696.392-.5.486-1.182 0-1.667-.406-.406-1.27-.5-1.669 0l.008.007z",
    fill: "url(#org-tutorial-step-2_svg__paint21_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.147 21.661a8.8 8.8 0 016.398 2.965c1.618 1.834 2.278 4.35 2.017 6.757-.073.63.594 1.174 1.175 1.174.696 0 1.11-.543 1.175-1.174.334-3.03-.696-6.14-2.706-8.424-2.009-2.284-5.027-3.596-8.066-3.661-1.516-.029-1.516 2.327 0 2.356l.007.007z",
    fill: "url(#org-tutorial-step-2_svg__paint22_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.686 17.63a14.557 14.557 0 003.177 4.039c.465.406 1.22.485 1.669 0 .413-.45.493-1.233 0-1.668a13.388 13.388 0 01-1.727-1.841l.182.24c-.479-.617-.9-1.27-1.262-1.958-.29-.544-1.096-.761-1.61-.42a1.201 1.201 0 00-.421 1.609h-.008z",
    fill: "url(#org-tutorial-step-2_svg__paint23_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.091 29.831c-.21-.275.015.015.051.073.066.08.124.167.189.247l.37.5a47.652 47.652 0 012.053 3.045c.326.521 1.066.775 1.61.42.544-.355.769-1.051.42-1.61a51.253 51.253 0 00-3.039-4.342c-.174-.217-.565-.348-.834-.348-.29 0-.63.13-.834.348-.203.218-.363.522-.348.834.014.333.145.572.348.833h.014z",
    fill: "url(#org-tutorial-step-2_svg__paint24_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88 46.629c.21.014.427.036.638.065l-.312-.044c.935.13 1.842.377 2.712.74l-.282-.116c.036.014.08.036.116.05.304.13.573.21.906.116.276-.072.573-.29.704-.543.145-.276.218-.602.116-.907-.087-.268-.268-.587-.544-.703a13.66 13.66 0 00-1.98-.696 11.955 11.955 0 00-2.082-.326c-.29-.022-.638.145-.834.348-.196.203-.356.537-.348.834.029.681.522 1.123 1.175 1.174l.014.008z",
    fill: "url(#org-tutorial-step-2_svg__paint25_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.044 55.183c.29.094.573.188.856.29.109.043.21.087.319.123-.406-.152-.029-.014.065.036.32.153.61.334.892.537.146.109-.253-.203-.115-.087l.094.072c.072.058.138.116.203.174.145.123.297.254.442.384.494.42 1.001.82 1.516 1.211.225.174.646.189.907.116.261-.072.573-.29.704-.544.145-.275.217-.601.116-.906-.102-.304-.283-.507-.544-.703a4.453 4.453 0 00-.225-.167 1.342 1.342 0 00-.03-.022 9.41 9.41 0 01-.311-.253c-.189-.152-.37-.312-.559-.471-.348-.298-.689-.595-1.059-.863-.783-.587-1.74-.906-2.662-1.203-.587-.189-1.313.217-1.45.819a1.209 1.209 0 00.82 1.45l.02.007z",
    fill: "url(#org-tutorial-step-2_svg__paint26_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.419 21.103c-.443 9.272-1.661 18.472-3.141 27.628-.24 1.486 2.031 2.124 2.27.623 1.516-9.359 2.778-18.776 3.228-28.25.073-1.516-2.285-1.516-2.357 0z",
    fill: "url(#org-tutorial-step-2_svg__paint27_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.035 44.881c6.159-1.493 11.563-5.553 14.725-11.04.762-1.32-1.276-2.502-2.038-1.19-2.873 4.98-7.733 8.606-13.318 9.961-1.472.355-.849 2.632.624 2.27h.007z",
    fill: "url(#org-tutorial-step-2_svg__paint28_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.666 43.026a6.958 6.958 0 011.161-4.11c.82-1.233 2.183-2.154 3.482-2.9 2.183-1.248 5.201-2.226 7.725-1.69 1.48.32 2.111-1.957.624-2.269-3.221-.689-6.92.377-9.706 2.015-1.639.972-3.191 2.124-4.229 3.741-1.037 1.617-1.479 3.386-1.421 5.205.043 1.515 2.401 1.523 2.357 0l.007.008z",
    fill: "url(#org-tutorial-step-2_svg__paint29_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.108 31.84c1.799.275 3.395-.37 4.867-1.37a20.572 20.572 0 003.627-3.147c2.198-2.436 4.178-5.59 4.316-8.946.065-1.515-2.292-1.515-2.358 0-.108 2.632-1.799 5.213-3.496 7.134-.834.95-1.77 1.834-2.793 2.58-.957.704-2.263 1.675-3.539 1.48-.632-.095-1.27.159-1.451.819-.153.558.188 1.355.819 1.45h.008z",
    fill: "url(#org-tutorial-step-2_svg__paint30_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24 30.042c.116-1.131.247-2.262.595-3.35.348-1.087 1.016-1.979 1.857-2.762.842-.782 1.879-1.515 2.829-2.24 1.103-.833 2.198-1.674 3.301-2.508.507-.384.768-1.015.42-1.61-.29-.5-1.102-.811-1.61-.42-1.219.928-2.445 1.856-3.663 2.784-1.096.834-2.249 1.638-3.235 2.61a8.622 8.622 0 00-2.148 3.429c-.442 1.312-.565 2.711-.71 4.074-.066.63.587 1.174 1.175 1.174.689 0 1.117-.543 1.175-1.174l.014-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint31_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.566 19.523c-1.611-1.624-3.395-3.393-3.932-5.691-.283-1.196-.079-2.414.189-3.596.297-1.334.645-2.646.776-4.009.065-.63-.588-1.174-1.175-1.174-.689 0-1.117.544-1.175 1.174-.283 2.864-1.61 5.532-.827 8.446.704 2.602 2.64 4.647 4.483 6.517 1.066 1.08 2.734-.587 1.668-1.667h-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint32_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.163 6.626a15.34 15.34 0 014.272 5.075c.624 1.188.298 2.247-.022 3.48-.34 1.333-.674 2.667-1.015 4.001-.377 1.472 1.9 2.095 2.27.623.37-1.471.777-3.023 1.154-4.53.399-1.603.5-3.016-.24-4.531-1.189-2.443-3.09-4.51-5.237-6.14-.508-.385-1.32-.08-1.61.42-.356.609-.087 1.225.421 1.61l.007-.008z",
    fill: "url(#org-tutorial-step-2_svg__paint33_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.824 18.03c.072-.29.166-.573.275-.856l-.116.283c.189-.45.435-.87.733-1.255l-.182.24a5.774 5.774 0 011.031-1.03l-.24.182c.298-.225.617-.428.95-.595.552-.275.748-1.102.421-1.61-.37-.565-1.023-.71-1.61-.42-1.748.856-3.083 2.552-3.54 4.437-.145.594.189 1.305.82 1.45.631.145 1.298-.181 1.45-.82l.008-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint34_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.537 1.769c.638 1.464 1.269 2.936 1.908 4.4.108.254.449.472.703.544.283.08.66.043.907-.116.247-.16.471-.406.544-.703.073-.326.015-.602-.116-.906-.638-1.465-1.269-2.936-1.908-4.4-.109-.255-.449-.472-.703-.545-.283-.08-.66-.043-.907.116-.247.16-.472.406-.544.704-.073.326-.015.601.116.906z",
    fill: "url(#org-tutorial-step-2_svg__paint35_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.636 34.435a7.126 7.126 0 002.06-1.53c.312-.34.602-.71.856-1.094.268-.406.464-.841.646-1.29.108-.262.014-.675-.116-.907-.146-.247-.421-.478-.704-.544-.305-.065-.638-.05-.907.116l-.239.181a1.187 1.187 0 00-.305.523l-.022.043.116-.283c-.21.486-.478.943-.797 1.363l.181-.24c-.327.421-.696.791-1.117 1.117l.239-.18a6.495 6.495 0 01-1.088.68c-.254.124-.471.443-.544.704-.08.282-.043.66.116.906.16.246.406.471.704.544.319.072.609.029.906-.116l.015.007z",
    fill: "url(#org-tutorial-step-2_svg__paint36_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.813 108.155c-3.235-14.369-6.463-28.737-9.698-43.098-1.56-6.93-3.003-13.905-5.266-20.647a103.727 103.727 0 00-7.668-17.413C53.7 20.733 49.53 14.847 44.705 9.54c-1.023-1.123-2.684.544-1.669 1.668 8.466 9.322 14.856 20.501 19.034 32.361 2.3 6.517 3.78 13.267 5.296 19.994 1.603 7.12 3.206 14.238 4.802 21.35 1.791 7.953 3.583 15.912 5.367 23.865.334 1.479 2.604.855 2.27-.623h.008z",
    fill: "url(#org-tutorial-step-2_svg__paint37_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.855 9.78c-3.474 5.32-3.786 11.86-3.286 18.014.58 7.156 1.727 14.29 2.64 21.415.457 3.574.871 7.155 1.538 10.7.61 3.248 1.393 6.453 2.213 9.65 1.625 6.365 3.242 12.722 4.794 19.109 1.64 6.756 3.2 13.528 4.766 20.298.341 1.479 2.611.849 2.27-.623-2.778-12.034-5.621-24.054-8.69-36.023-1.675-6.546-3.242-13.041-4.105-19.747-.921-7.206-1.922-14.412-2.756-21.632-.777-6.699-1.197-14.064 2.654-19.965.835-1.276-1.211-2.458-2.038-1.19V9.78z",
    fill: "url(#org-tutorial-step-2_svg__paint38_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44 46.259c-.254-1.146-.443-2.342-.102-3.495.34-1.152 1.117-1.913 1.784-2.805.668-.892 1.132-1.87 1.756-2.777.754-1.102 1.443-2.363 2.336-3.356.319-.355.623-.71.928-1.087.363-.457.5-.479.921-.827.472-.391-1.03.073-.921-.319-.022.073.058.254.058.305.043.435-.058.891-.16 1.312-.471 2.044-1.247 4.081-2.502 5.77-1.806 2.436-3.7 4.72-5.912 6.8-1.023.965.522 2.501 1.538 1.537 2.343-2.218 4.33-4.661 6.253-7.242 1.45-1.957 2.48-4.589 2.858-7.003.152-.993.21-2.197-.588-2.958-.928-.877-2.292.13-2.93.9-.936 1.13-1.836 2.24-2.64 3.464-.429.646-.886 1.27-1.314 1.914-.348.53-.616 1.102-.964 1.631-.82 1.269-1.916 2.32-2.452 3.756-.617 1.638-.4 3.385-.037 5.052.298 1.363 2.401.79 2.097-.58l-.008.008z",
    fill: "url(#org-tutorial-step-2_svg__paint39_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.552 66.717c-.333-1.4-.587-2.871-.101-4.263.45-1.298 1.487-2.255 2.314-3.313.827-1.058 1.501-2.305 2.328-3.407 1.052-1.4 2.01-2.864 3.235-4.125.378-.384.704-.827 1.06-1.225.224-.254.007-.08.34-.297.095-.059.588-.283.617-.37.029-.109-.9 0-.813-.218.015-.043.059.116.066.102-.015.043.036.254.043.326.051.544-.108 1.124-.239 1.646-.631 2.45-1.64 4.806-3.242 6.77-2.307 2.828-4.665 5.488-7.421 7.895-1.06.92.486 2.458 1.538 1.537 2.829-2.472 5.259-5.212 7.609-8.127 1.857-2.305 3.228-5.292 3.772-8.22.218-1.153.334-2.567-.58-3.466-.914-.899-2.38.044-3.141.79-1.212 1.197-2.322 2.567-3.3 3.959-.545.776-1.125 1.515-1.684 2.276-.507.689-.9 1.45-1.385 2.146-1.037 1.486-2.408 2.675-3.083 4.393-.74 1.863-.479 3.864-.022 5.763.327 1.363 2.423.783 2.097-.58l-.008.008z",
    fill: "url(#org-tutorial-step-2_svg__paint40_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.739 86.399c-.334-1.4-.588-2.87-.102-4.263.45-1.297 1.487-2.254 2.314-3.313.827-1.058 1.502-2.305 2.329-3.407 1.051-1.4 2.009-2.864 3.235-4.125.377-.384.703-.826 1.059-1.225.225-.254.007-.08.34-.297.095-.058.588-.283.617-.37.03-.109-.9 0-.812-.218.015-.043.058.117.065.102-.014.043.036.254.044.326.05.544-.11 1.124-.24 1.646-.63 2.45-1.639 4.806-3.242 6.77-2.307 2.828-4.664 5.489-7.42 7.895-1.06.921.485 2.458 1.537 1.537 2.83-2.472 5.26-5.212 7.61-8.126 1.856-2.306 3.227-5.292 3.771-8.221.218-1.153.334-2.566-.58-3.465-.914-.9-2.38.043-3.14.79-1.212 1.196-2.322 2.566-3.301 3.958-.544.776-1.125 1.515-1.683 2.276-.508.689-.9 1.45-1.386 2.146-1.037 1.486-2.408 2.675-3.082 4.393-.74 1.864-.48 3.864-.022 5.764.326 1.363 2.422.783 2.096-.58l-.007.007z",
    fill: "url(#org-tutorial-step-2_svg__paint41_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.99 104.871c0-2.328.478-4.357 1.85-6.242.797-1.095 1.638-2.146 2.415-3.263.943-1.355 1.871-2.776 2.916-4.052.391-.478.856-.877 1.255-1.348.478-.573.66-.856 1.153-1.167.384-.24.704-.21.058-.377-.784-.203-.276-.174-.312.094-.05.42.05.884-.022 1.326-.413 2.603-1.77 4.85-3.264 6.96-2.01 2.834-4.49 5.031-7.101 7.3-1.06.921.486 2.45 1.537 1.537 2.677-2.327 5.172-4.596 7.262-7.496 1.813-2.508 3.401-5.278 3.764-8.41.123-1.065.036-2.624-1.052-3.21-1.088-.588-2.582.746-3.25 1.522-.478.558-1.008 1.058-1.48 1.616-.724.848-1.334 1.805-1.994 2.712-.943 1.297-1.806 2.653-2.8 3.914-.79 1-1.581 2.008-2.11 3.183-.77 1.703-.994 3.552-1.002 5.408 0 1.399 2.176 1.399 2.176 0v-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint42_linear_9824_14693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.774 163.613c.175 2.443.102 4.857-.094 7.3-.174 2.16.073 4.234 1.19 6.126.972 1.645 2.495 3.074 4.33 3.675 1.835.602 3.845.319 5.73.377 1.517.051 1.517-2.305 0-2.356-1.595-.051-3.336.21-4.888-.232-1.553-.442-2.684-1.732-3.38-3.088-.864-1.689-.712-3.48-.56-5.299.182-2.161.182-4.328.03-6.496-.109-1.501-2.466-1.515-2.358 0v-.007z",
    fill: "url(#org-tutorial-step-2_svg__paint43_linear_9824_14693)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint0_linear_9824_14693",
    x1: 41.995,
    y1: 60.719,
    x2: 19.944,
    y2: 57.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint1_linear_9824_14693",
    x1: 46.279,
    y1: 63.82,
    x2: 33.182,
    y2: 54.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint2_linear_9824_14693",
    x1: 48.047,
    y1: 95.86,
    x2: 22.359,
    y2: 90.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint3_linear_9824_14693",
    x1: 85.05,
    y1: 67.927,
    x2: 75.298,
    y2: 59.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint4_linear_9824_14693",
    x1: 81.602,
    y1: 56.312,
    x2: 59.432,
    y2: 49.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint5_linear_9824_14693",
    x1: 80.68,
    y1: 61.92,
    x2: 66.719,
    y2: 56.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint6_linear_9824_14693",
    x1: 28.964,
    y1: 126.502,
    x2: 2.387,
    y2: 123.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint7_linear_9824_14693",
    x1: 25.552,
    y1: 76.438,
    x2: -4.442,
    y2: 68.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint8_linear_9824_14693",
    x1: 150.743,
    y1: 166.324,
    x2: 104.082,
    y2: 154.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint9_linear_9824_14693",
    x1: 156.991,
    y1: 111.06,
    x2: 90.097,
    y2: 96.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint10_linear_9824_14693",
    x1: 127.594,
    y1: 109.907,
    x2: 66.841,
    y2: 98.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint11_linear_9824_14693",
    x1: 126.655,
    y1: 94.327,
    x2: 106.238,
    y2: 89.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint12_linear_9824_14693",
    x1: 141,
    y1: 188.004,
    x2: 11.905,
    y2: 143.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint13_linear_9824_14693",
    x1: 140.617,
    y1: 129.016,
    x2: 47.13,
    y2: 60.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint14_linear_9824_14693",
    x1: 107.172,
    y1: 92.314,
    x2: 104.486,
    y2: 91.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint15_linear_9824_14693",
    x1: 112.883,
    y1: 92.162,
    x2: 106.881,
    y2: 85.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint16_linear_9824_14693",
    x1: 124.467,
    y1: 100.703,
    x2: 120.764,
    y2: 100.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint17_linear_9824_14693",
    x1: 97.229,
    y1: 53.813,
    x2: 89.221,
    y2: 52.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint18_linear_9824_14693",
    x1: 103.71,
    y1: 50.802,
    x2: 91.023,
    y2: 43.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint19_linear_9824_14693",
    x1: 104.207,
    y1: 44.629,
    x2: 90.502,
    y2: 41.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint20_linear_9824_14693",
    x1: 104.656,
    y1: 44.318,
    x2: 90.381,
    y2: 40.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint21_linear_9824_14693",
    x1: 105.582,
    y1: 32.588,
    x2: 91.743,
    y2: 29.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint22_linear_9824_14693",
    x1: 105.974,
    y1: 32.557,
    x2: 91.736,
    y2: 29.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint23_linear_9824_14693",
    x1: 95.873,
    y1: 22.004,
    x2: 89.508,
    y2: 20.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint24_linear_9824_14693",
    x1: 94.951,
    y1: 34.281,
    x2: 88.678,
    y2: 33.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint25_linear_9824_14693",
    x1: 92.525,
    y1: 47.482,
    x2: 86.474,
    y2: 44.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint26_linear_9824_14693",
    x1: 92.09,
    y1: 58.08,
    x2: 84.295,
    y2: 55.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint27_linear_9824_14693",
    x1: 107.778,
    y1: 50.211,
    x2: 100.895,
    y2: 49.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint28_linear_9824_14693",
    x1: 120.928,
    y1: 44.92,
    x2: 102.358,
    y2: 39.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint29_linear_9824_14693",
    x1: 120.507,
    y1: 44.157,
    x2: 102.224,
    y2: 38.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint30_linear_9824_14693",
    x1: 118.919,
    y1: 31.903,
    x2: 102.707,
    y2: 28.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint31_linear_9824_14693",
    x1: 117.401,
    y1: 31.223,
    x2: 103.555,
    y2: 28.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint32_linear_9824_14693",
    x1: 107.916,
    y1: 21.54,
    x2: 99.58,
    y2: 20.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint33_linear_9824_14693",
    x1: 110.131,
    y1: 20.646,
    x2: 100.81,
    y2: 19.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint34_linear_9824_14693",
    x1: 121.855,
    y1: 18.89,
    x2: 115.485,
    y2: 17.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint35_linear_9824_14693",
    x1: 104.631,
    y1: 6.754,
    x2: 99.457,
    y2: 5.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint36_linear_9824_14693",
    x1: 123.245,
    y1: 34.578,
    x2: 116.883,
    y2: 33.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint37_linear_9824_14693",
    x1: 79.839,
    y1: 109.623,
    x2: 33.832,
    y2: 105.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint38_linear_9824_14693",
    x1: 57.825,
    y1: 109.81,
    x2: 34.819,
    y2: 108.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint39_linear_9824_14693",
    x1: 56.367,
    y1: 47.623,
    x2: 42.508,
    y2: 45.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint40_linear_9824_14693",
    x1: 62.811,
    y1: 68.067,
    x2: 46.049,
    y2: 65.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint41_linear_9824_14693",
    x1: 67.998,
    y1: 87.749,
    x2: 51.235,
    y2: 84.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint42_linear_9824_14693",
    x1: 72.544,
    y1: 105.927,
    x2: 55.894,
    y2: 103.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "org-tutorial-step-2_svg__paint43_linear_9824_14693",
    x1: 47.068,
    y1: 181.108,
    x2: 31.942,
    y2: 178.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "org-tutorial-step-2_svg__clip0_9824_14693"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h157v188H0z"
  })))));
}
export default SvgOrgTutorialStep2;